import megamenu from 'components/megamenu'

const navigation = {
  el: {
    container: null as HTMLElement | null,
  },
  _boundNavClickHandler: null as ((e: MouseEvent) => void) | null,

  init() {
    this.el.container = document.querySelector('.header-navigation') // Parent container
    if (!this.el.container) {
      return
    }

    this._boundNavClickHandler = this._navClickhandler.bind(this)
    this.el.container.addEventListener('click', this._boundNavClickHandler)
  },

  _navClickhandler(e: MouseEvent) {
    const target = e.target as HTMLElement
    const link = target.closest('.navigation__link') as HTMLAnchorElement | null

    if (!link) {
      return // Click was not on a navigation link
    }

    e.stopImmediatePropagation()

    const links = this.el.container?.querySelectorAll<HTMLAnchorElement>('.navigation__link')
    links.forEach((l) => {
      l.classList.remove('navigation-active')
      l.removeAttribute('aria-current')
    })

    megamenu.close()

    link.classList.add('navigation-active')
    link.setAttribute('aria-current', 'page')
    e.stopPropagation()
  },
}

export default navigation
